/**
 * External dependencies
 */
import styled from '@emotion/styled';

/**
 * Internal dependencies
 */
import { text } from './mixins';

export const __experimentalText = styled.p( `margin: 0;`, text );
